<script>
import ListingModel from "@/views/Training/TrainingSession/Components/ListingModel.vue";

export default {
    name: "TrainingSessions",
    components: {ListingModel},

};
</script>

<template>
    <ListingModel type="SESSION"/>
</template>